/* eslint react/jsx-no-bind: 0 */
import PropTypes from 'prop-types';
import React from 'react';
import BrandingBanner from '../common/branding_banner';
import Lazy from '../common/lazy';
import ResponsiveImg from '../common/responsive_img';
import classNames from 'classnames';
import { SOCIAL_ICONS } from '../social_icons_new';


const PageHeaderModule = (props) => {
  const {
    campaign_branding_image_mobile_url,
    image_url,
    title,
    bio,
    role,
    socials
  } = props;

  function extractData(firstMatch, secondMatch) {
    if (bio) {
      const firstSplit = bio.split(firstMatch)[1];
      if (firstSplit) {
        const secondSplit = firstSplit.split(secondMatch)[0];
        return secondSplit || null;
      }
    }
    return bio;
  }

  function extractBio() {
    return extractData('<!-- wp:paragraph -->', '<!-- /wp:paragraph -->');
  }

  const extractedBio = extractBio();
  return (
    <div className={classNames('module', 'page-header', {
      'with-image': !!image_url
    })}
    >
      <div className="page-header-content">
        {
          campaign_branding_image_mobile_url &&
          <BrandingBanner type="campaign"
            src={campaign_branding_image_mobile_url}
          />
        }
        {
          image_url &&
          <Lazy className="image">
            <ResponsiveImg src={image_url}
              width={140}
              height={140}
            />
          </Lazy>
        }
        <h1 className="title" dangerouslySetInnerHTML={{ __html: title }} />
        {
          role &&
          <div className="subtitle">
            {role && (<h3>{role}</h3>)}
          </div>
        }
        {
          extractedBio && (
            <div className="bio">
              <h2 dangerouslySetInnerHTML={{ __html: extractedBio }} />
            </div>
          )
        }
        {
          socials && Object.keys(socials).map((key) => {
            return socials[key] && (<a href={key === 'email' ? `mailto:${socials[key]}` : socials[key]} target="_blank">{SOCIAL_ICONS[key]}</a>)
          })
        }
      </div>
    </div>
  )
};

PageHeaderModule.propTypes = {
  campaign_branding_image_mobile_url: PropTypes.string,
  image_url: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string
};

export default PageHeaderModule;
